import { render, staticRenderFns } from "./busLeftDataWidthFit.vue?vue&type=template&id=39a31b05&scoped=true&"
import script from "./busLeftDataWidthFit.vue?vue&type=script&lang=js&"
export * from "./busLeftDataWidthFit.vue?vue&type=script&lang=js&"
import style0 from "./busLeftDataWidthFit.vue?vue&type=style&index=0&id=39a31b05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a31b05",
  null
  
)

export default component.exports